import React from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'

// next components
import Image from 'next/image'

// functions
import { useViewport } from 'utils'

// images and icons
import SolanaLogoIcon from 'assets/icons/solana-logo-14x12.svg?component'
import DefaultAvatar from 'assets/images/dashboard-avatar.png'

// styles
import styles from './index.module.scss'
import { getDisplayUserName } from 'utils/strings'
import Link from 'next/link'

const CollectionsTable = props => {
  const { data } = props
  const viewport = useViewport()
  const router = useRouter()
  const dispatch = useDispatch()
  return (
    <table id="ArtworksTable" className="w-full table-auto">
      <thead>
        <tr>
          <th className="w-[20%] text-start">
            <div className="ml-3">Collection</div>
          </th>
          <th>Total Sales</th>
          <th>Floor Price</th>
          <th>Average Sale</th>
          <th>Highest Sale</th>
          <th>Creator</th>
          <th>Unique Holders</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          return (
            <tr key={item.collection_address}>
              <td>
                <Link href={`/collection/${item.collection_address}`} passHref>
                  <a>
                    <div className="flex gap-2 mx-3 items-center">
                      <div className="min-w-[38px] w-[38x]">
                        <Image
                          src={item.cover_image !== null && item.cover_image !== '' ? item.cover_image : DefaultAvatar}
                          alt=""
                          width={38}
                          height={38}
                          className="rounded-[8px]"
                        />
                      </div>
                      <div className="flex justify-center cursor-pointer">{item.collection_name}</div>
                    </div>
                  </a>
                </Link>
              </td>
              <td className="text-center">
                <div className={`flex justify-center items-center gap-[5px] ${styles.priceText}`}>
                  <SolanaLogoIcon className="mt-[3px]" />
                  {item.total_sales.toFixed(2)}
                </div>
              </td>
              <td className="text-center">
                <div className={`flex justify-center items-center gap-[5px] ${styles.priceText}`}>
                  <SolanaLogoIcon className="mt-[3px]" />
                  {item.floor_price?.toFixed(2)}
                </div>
              </td>
              <td className="text-center">
                <div className={`flex justify-center items-center gap-[5px] ${styles.priceText}`}>
                  <SolanaLogoIcon className="mt-[3px]" />
                  {item.average_sale?.toFixed(2)}
                </div>
              </td>
              <td className="text-center">
                <div className={`flex justify-center items-center gap-[5px] ${styles.priceText}`}>
                  <SolanaLogoIcon className="mt-[3px]" />
                  {item.highest_sale?.toFixed(2)}
                </div>
              </td>
              <td
                className="text-center cursor-pointer"
                onClick={() => {
                  router.push(`/${item.creator_username}`)
                }}
              >
                <Link href={`/${item.creator_username}`} passHref>
                  <a>{getDisplayUserName(item.creator_username)}</a>
                </Link>
              </td>
              <td className="text-center">{item.unique_holders}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default CollectionsTable
